import { ReactComponent as ForbiddenSVG } from '@/asset/svg/403.svg'
import TGASDK from '@/config/TGASDK'
import useAppLogin from '@/hook/useAppLogin'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Button from '../Button'

const Forbidden: React.FC<PropType> = ({ message, onBack }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const appLogin = useAppLogin()
  const [pedding, setPedding] = useState(false)

  const { enabled, appLoginEnabled } = TGASDK.context.appConfig.feature.uc

  const handleLoginClick = async () => {
    setPedding(true)
    try {
      await appLogin()
    } finally {
      setPedding(false)
    }
  }
  const handleBackClick = () => {
    if (onBack) {
      return onBack()
    }

    navigate(-1)
  }

  return (
    <div className="flex flex-col justify-center gap-md px-md py-14 text-center">
      <div className="mb-md flex flex-col items-center justify-center text-fontcolor-400">
        <ForbiddenSVG className="aspect-square w-36 fill-gray-500" />
        <p>{message ? message : t('message.forbidden')}</p>
      </div>
      <div className="flex flex-col gap-md">
        {enabled && appLoginEnabled && (
          <Button type="primary" loading={pedding} onClick={handleLoginClick}>
            {t('btn.login')}
          </Button>
        )}
        <Button onClick={handleBackClick}>{t('btn.back')}</Button>
      </div>
    </div>
  )
}

export interface PropType {
  message?: string
  onBack?: () => void
}

export default Forbidden
